module.exports = __webpack_public_path__ + "static/media/daniel-olahs.af300b6e.jpg";